<template>
	<app-content class="h-panel">
		<Tabs :datas="tabDatas" v-model="selected" @change="change"></Tabs>
		<div class="padding-right-left padding-top">
			<span class="dark4-color">*提示：按 Ctrl + F 键并输入科目编码或者科目名称可以查找科目。</span>
			<div class="pull-right subject-toolbar">
				<Checkbox v-model="showSubjectId">显示科目ID</Checkbox>
				<Checkbox v-model="showDisabled">显示停用科目</Checkbox>
				<Button @click="create()" v-if="currentAccountSets.accountingStandards !== 0" color="primary">新增科目</Button>
				<Button @click="exportData">导出</Button>
				<Button :loading="loading" @click="doUpload">
					<input ref="file" type="file" accept="application/vnd.ms-excel" style="display: none" @change="fileChange($event)">
					导入
				</Button>
				<DropdownMenu button :datas="moreMenu" @click="menuClick" :width="150" placement="bottom-end">更多</DropdownMenu>
			</div>
		</div>
		<div class="h-panel-body padding">
			<Table ref="subjectTable" :datas="displayDatas" border :loading="loading">
				<TableItem :width="40" align="center">
					<div slot-scope="{data}">
						<input type="checkbox" v-model="data._checked">
					</div>
				</TableItem>
				<TableItem title="科目ID" prop="id" :width="90" align="center" v-if="showSubjectId"></TableItem>
				<TableItem title="科目编码">
					<template slot-scope="{data}">
						<span :style="{paddingLeft:(data.level-1)*15+'px'}">{{data.code}}</span>
					</template>
				</TableItem>
				<TableItem title="科目名称">
					<template slot-scope="{data}">
						{{data.name}}
					</template>
				</TableItem>
				<TableItem title="助记码" prop="mnemonicCode"></TableItem>
				<TableItem title="余额方向" prop="balanceDirection" align="center" :width="100"></TableItem>
				<TableItem title="数量核算" v-if="showUnit" prop="unit" align="center" :width="100"></TableItem>
				<TableItem title="辅助核算" v-if="showAssistAccounting">
					<template slot-scope="{data:{auxiliaryAccounting}}">
						{{auxiliaryAccounting?JSON.parse(auxiliaryAccounting).map(val=>val.name).join(','):''}}
					</template>
				</TableItem>
				<TableItem title="状态" align="center" :width="100">
					<template slot-scope="{data}">
						<HSwitch v-model="data.status" :small="true" @change="toggleStatus(data)"></HSwitch>
					</template>
				</TableItem>
				<TableItem title="操作" :width="150" align="center">
					<div class="actions" slot-scope="{data}">
						<span @click="create(data)" v-if="data.level < codeLen.length">新增</span>
						<span v-if="!data.isLeaf" @click="edit(data)">编辑</span>
						<span v-if="!data.systemDefault" @click="remove(data)">删除</span>
					</div>
					</TableItem>
			</Table>
		</div>
		<Modal v-model="showForm" type="drawer-right" hasCloseIcon>
			<div slot="header">新增科目</div>
			<Form :readonly="used" ref="form" v-width="800" mode="twocolumn" :labelWidth="150" :model="form" :rules="validationRules">
				<img v-if="used" class="used" src="@/assets/used.png" alt="已使用">
				<FormItem label="科目编码" prop="code">
					<div class="h-input-group" v-if="!form.id && parent">
						<span class="h-input-addon bg-white-color" style="padding-right: 0;border-right: none;line-height: 32px;;color: #001529;">{{parent.code}}</span>
						<input style="padding-left: 0;border-left: none;" type="text" v-model="form.code" :maxlength="len">
					</div>
					<input v-else-if="!form.id && !parent" type="text" v-model="form.code" :maxlength="len">
					<input v-else type="text" v-model="form.code" disabled>
				</FormItem>
				<FormItem label="科目名称" prop="name">
					<input type="text" v-model="form.name" :disabled="form.systemDefault || used">
				</FormItem>
				<FormItem label="上级科目">
					<input type="text" :value="parentSubject" disabled>
				</FormItem>
				<FormItem label="余额方向">
					<Radio v-model="form.balanceDirection" :datas="['借','贷']" :disabled="parent"/>
				</FormItem>
				<FormItem label="状态">
					<Radio v-model="form.status" dict="statusRadios" :disabled="used"></Radio>
				</FormItem>
				<FormItem single label="">
					<Row type="flex" :space-x="10">
						<Cell>
							<Checkbox v-model="numberAccounting" :disabled="used">数量核算</Checkbox>
						</Cell>
						<template v-if="numberAccounting">
							<Cell class="label">计量单位</Cell>
							<Cell><input type="text" v-width="100" v-model="unit" :disabled="used"></Cell>
						</template>
					</Row>
				</FormItem>
				<FormItem single label="">
					<Row type="flex" :space-x="10">
						<Cell>
							<Checkbox v-model="assistAccounting" :disabled="used">辅助核算</Checkbox>
						</Cell>
						<template v-if="assistAccounting">
							<Cell>
								<Checkbox v-model="auxiliaryAccounting" :datas="accountingCategory" keyName="id" titleName="name" :disabled="used"></Checkbox>
							</Cell>
						</template>
					</Row>
				</FormItem>
			</Form>
			<div class="text-center">
				<Button color="green" @click="submit" :disabled="used" :loading="loading">{{form.id?'保存':'保存'}}</Button>
				<Button @click="showForm=false">取消</Button>
			</div>
		</Modal>
		<Modal v-model="encodingSettingForm" :width="720">
			<div slot="header">编码设置</div>
			<div class="padding encode-box">
				<div class="encode-rule">
					<span class="encode-label">科目编码规则：</span>
					<span class="encode-first">4</span>
					<template v-for="(len, idx) in codeLen">
						<span v-if="idx > 0" :key="'sep'+idx" class="encode-sep">-</span>
						<span v-if="idx > 0" :key="'sel'+idx" class="encode-item">
							<Select v-model="codeLen[idx]" :datas="lenData" :deletable="false"/>
							<span v-if="idx === codeLen.length - 1 && codeLen.length > 2" class="encode-del" title="删除最后一级" @click="removeLevel">×</span>
						</span>
					</template>
					<span v-if="codeLen.length < 8" class="encode-add" title="增加一级" @click="addLevel">+</span>
				</div>
				<div class="encode-tip">* 第一级固定为 4 位，其余级次长度可在 1-4 位之间调整；点击 + 可增加级次（最多 8 级），鼠标移至最后一级显示 × 可删除。缩短长度或减少级次时系统会校验现有科目，可能造成编码重复的修改将无法保存。</div>
			</div>
			<div class="text-center">
				<Button color="primary" @click="saveEncoding" :loading="loading">保存</Button>
				<Button @click="encodingSettingForm=false" :loading="loading">取消</Button>
			</div>
		</Modal>
		<Modal v-model="mergeForm.show" :width="540">
			<div slot="header">科目合并</div>
			<div class="merge-box padding">
				<div class="m-row">
					<div class="m-label">源科目（将被删除）</div>
					<select v-model="mergeForm.sourceId">
						<option v-for="s in mergeForm.subjects" :value="s.id" :key="'s'+s.id">{{s.code}} - {{s.name}}</option>
					</select>
				</div>
				<div class="m-row">
					<div class="m-label">目标科目（保留）</div>
					<select v-model="mergeForm.targetId">
						<option v-for="s in mergeForm.subjects" :value="s.id" :key="'t'+s.id">{{s.code}} - {{s.name}}</option>
					</select>
				</div>
				<div class="m-tip">合并后，源科目的凭证、期初余额、凭证模板、自动转账模板引用全部迁移到目标科目，随后删除源科目。两个科目余额方向必须一致，且都不能有下级科目。</div>
			</div>
			<div class="text-center">
					<Button color="green" :loading="loading" @click="doMerge">执行合并</Button>
					<Button @click="mergeForm.show=false">取消</Button>
				</div>
			</Modal>
			<Modal v-model="batchAuxForm.show" :width="460">
				<div slot="header">批量设置辅助核算</div>
				<div class="padding">
					<Checkbox v-model="batchAuxForm.auxiliaryAccounting" :datas="accountingCategory" keyName="id" titleName="name"></Checkbox>
					<div class="batch-tip">对勾选的科目生效；不勾选任何辅助项直接保存，则清空所选科目的辅助核算。</div>
				</div>
				<div class="text-center">
					<Button color="green" @click="doBatchAuxiliary" :loading="loading">保存</Button>
					<Button @click="batchAuxForm.show=false">取消</Button>
				</div>
			</Modal>
			<Modal v-model="cashFlowForm.show" :width="680">
				<div slot="header">现金流量对照</div>
				<div class="padding">
					<Row type="flex" :space-x="10" class="margin-bottom">
						<Cell><input type="text" v-model="cashFlowForm.keyword" placeholder="搜索科目编码或名称" style="width: 200px"/></Cell>
						<Cell>
							<Checkbox v-model="cashFlowForm.cashOnly">仅现金/银行类</Checkbox>
						</Cell>
					</Row>
					<div class="cashflow-list">
						<Table :datas="cashFlowDisplayDatas" border>
							<TableItem title="科目编码" :width="110">
								<template slot-scope="{data}">{{data.code}}</template>
							</TableItem>
							<TableItem title="科目名称">
								<template slot-scope="{data}">{{data.name}}</template>
							</TableItem>
							<TableItem title="现金流量项目" :width="300">
								<template slot-scope="{data}">
									<Select v-model="data.cashFlowItem" :datas="cashFlowOptions" keyName="id" titleName="title" :filterable="true" nullOptionText="未对照" @change="value => changeCashFlow(data, value)"></Select>
								</template>
							</TableItem>
						</Table>
					</div>
					<div class="batch-tip">为现金/银行类科目指定现金流量项目，作为现金流量分类的对照依据；选择"未对照"可取消对照，修改即时保存。</div>
			</div>
		</Modal>
	</app-content>
</template>

<script>

	import Pinyin from 'chinese-to-pinyin'
	import StringUtils from 'string-utilz'
	import {mapState} from 'vuex';

	const emptyForm = {
		"code": "",
		"name": "",
		"mnemonicCode": "",
		"balanceDirection": "借",
		"auxiliaryAccounting": null,
		"status": true
	};

	export default {
		name: "Subject",
		data() {
			return {
				codeLen: [4, 2, 2, 2],
			lenData: [1, 2, 3, 4],
				tabDatas: [{
					title: '资产',
					key: 'CodeAssets'
				}, {
					title: '负债',
					key: 'CodeLiabilities'
				}, {
					title: '权益',
					key: 'CodeInterest'
				}, {
					title: '成本',
					key: 'CodeCost'
				}, {
					title: '损益',
					key: 'CodeLoss'
				}],
				datas: [],
				accountingCategory: [],
				auxiliaryAccounting: [],
				unit: '',
				validationRules: {
					required: ["code", "name"]
				},
				parent: null,
				len: 2,
				showSubjectId: false,
				showDisabled: false,
				moreMenu: [{
					title: '编码设置',
					key: 'encoding'
				}, {
					title: '科目合并',
					key: 'merge'
				}, {
					title: '批量设置辅助核算',
					key: 'batchAuxiliary'
				}, {
					title: '关闭下级科目',
					key: 'disableChildren'
				}, {
					title: '批量删除',
					key: 'batchDelete'
				}, {
					title: '现金流量对照',
					key: 'cashFlow'
				}],
				batchAuxForm: {show: false, auxiliaryAccounting: []},
				cashFlowForm: {show: false, items: [], datas: [], keyword: '', cashOnly: true},
				encodingSettingForm: false,
				mergeForm: {show: false, sourceId: null, targetId: null, subjects: []},
			numberAccounting: false,
				assistAccounting: false,
				form: HeyUtils.copy(emptyForm),
				showForm: false,
				used: false,
				type: "资产",
				selected: 'CodeAssets',
				loading: false
			};
		},
		computed: {
			...mapState(['currentAccountSets']),
			parentSubject() {
				return this.parent ? this.parent.name : '';
			},
			showUnit() {
				return this.datas.find(value => !!value.unit)
			},
			showAssistAccounting() {
				return this.datas.find(value => !!value.auxiliaryAccounting)
			},
			displayDatas() {
				return this.filterDatas(this.datas);
			},
			cashFlowOptions() {
				return (this.cashFlowForm.items || []).filter(item => !item.isBolder && !item.isClassified);
			},
			cashFlowDisplayDatas() {
				let keyword = (this.cashFlowForm.keyword || '').trim();
				return (this.cashFlowForm.datas || []).filter(item => {
					if (this.cashFlowForm.cashOnly && !this.isCashSubject(item.code)) {
						return false;
					}
					if (keyword && (item.code || '').indexOf(keyword) < 0 && (item.name || '').indexOf(keyword) < 0) {
						return false;
					}
					return true;
				});
			}
		},
		watch: {
			type() {
				this.loadList()
			},
			showForm(val) {
				if (!val) {
					this.parent = null;
					this.used = false;
					this.form = HeyUtils.copy(emptyForm);
					this.numberAccounting = false;
					this.assistAccounting = false;
					this.unit = '';
					this.auxiliaryAccounting = [];
				}
			},
			numberAccounting(val) {
				if (!val) {
					this.form.unit = '';
				}
			}
		},
		methods: {
			encodingSetting() {
			this.encodingSettingForm = true;
		},
		flatten(list) {
			let result = [];
			(list || []).forEach(item => {
				result.push(item);
				if (item.children && item.children.length) {
					result = result.concat(this.flatten(item.children));
				}
			});
			return result;
		},
		openMerge() {
			this.mergeForm = {show: true, sourceId: null, targetId: null, subjects: []};
			this.$api.setting.subject.voucherSelect({showAll: true}).then(({data}) => {
				this.mergeForm.subjects = this.flatten(data || []);
			});
		},
		doMerge() {
			if (!this.mergeForm.sourceId || !this.mergeForm.targetId) {
				this.$Message('请选择源科目和目标科目');
				return;
			}
			if (this.mergeForm.sourceId === this.mergeForm.targetId) {
				this.$Message('源科目和目标科目不能相同');
				return;
			}
			this.$Confirm('确认执行科目合并？合并后源科目将被删除，请谨慎操作。').then(() => {
				this.$api.setting.subject.merge({
					sourceId: this.mergeForm.sourceId,
					targetId: this.mergeForm.targetId
				}).then(() => {
					this.$Message('科目合并完成');
					this.mergeForm.show = false;
					this.loadList();
				});
			});
		},
			saveEncoding() {
			let code = this.codeLen.join('-');
			if (code !== this.currentAccountSets.encoding) {
				this.loading = true;
				this.$api.setting.accountSets.updateEncode({encoding: this.currentAccountSets.encoding, newEncoding: code}).finally(() => {
					this.encodingSettingForm = false;
					this.loading = false;
				}).then(() => {
					this.loadList();
					this.$store.dispatch('init');
				});
			} else {
				this.encodingSettingForm = false;
			}
		},
		addLevel() {
			if (this.codeLen.length < 8) {
				this.codeLen.push(2);
			}
		},
		removeLevel() {
			if (this.codeLen.length > 2) {
				this.codeLen.splice(this.codeLen.length - 1, 1);
			}
		},
			toPy() {
				let pyArr = [];
				this.form.name.split("").forEach(w => {
					w = w.trim();
					if (w) {
						if (/[\u4e00-\u9fa5]/.test(w)) {
							let py = Pinyin(w, {removeTone: true, keepRest: true}).trim();
							pyArr.push(py.substring(0, 1));
						} else {
							pyArr.push(w);
						}
					}
				});

				if (this.parent) {
					this.$set(this.form, 'mnemonicCode', this.parent.mnemonicCode + "_" + pyArr.join(""));
					if (!this.form.id) {
						this.$set(this.form, 'code', this.parent.code + this.form.code);
					}
				} else {
					this.$set(this.form, 'mnemonicCode', pyArr.join(""));
				}
			},
			loadList() {
				this.loading = true;
				this.$api.setting.subject.list(this.type).then(({data}) => {
					this.datas = data || [];
					this.prepareCheck(this.datas);
					this.loading = false
				});
			},
			prepareCheck(list) {
				(list || []).forEach(item => {
					this.$set(item, '_checked', false);
					this.prepareCheck(item.children);
				});
			},
			filterDatas(list) {
				let result = [];
				(list || []).forEach(item => {
					let children = this.filterDatas(item.children);
					if ((this.showDisabled || item.status) || children.length) {
						result.push(item.children && item.children.length ? Object.assign({}, item, {children: children}) : item);
					}
				});
				return result;
			},
			exportData() {
				window.open(this.$api.setting.subject.exportUrl(this.type));
			},
			menuClick(key) {
				switch (key) {
					case 'encoding':
						this.encodingSetting();
						break;
					case 'merge':
						this.openMerge();
						break;
					case 'batchAuxiliary':
						this.openBatchAuxiliary();
						break;
					case 'disableChildren':
						this.doDisableChildren();
						break;
					case 'batchDelete':
						this.doBatchDelete();
						break;
					case 'cashFlow':
						this.openCashFlow();
						break;
				}
			},
			getSelectedIds() {
				return this.flatten(this.displayDatas).filter(item => item._checked).map(item => item.id);
			},
			openBatchAuxiliary() {
				if (!this.getSelectedIds().length) {
					this.$Message('请先勾选科目');
					return;
				}
				this.batchAuxForm = {show: true, auxiliaryAccounting: []};
			},
			doBatchAuxiliary() {
				let ids = this.getSelectedIds();
				if (!ids.length) {
					this.$Message('请先勾选科目');
					this.batchAuxForm.show = false;
					return;
				}
				this.loading = true;
				let value = this.batchAuxForm.auxiliaryAccounting.length ?
					JSON.stringify(this.batchAuxForm.auxiliaryAccounting.map(value => {
						let act = this.accountingCategory.find(item => item.id == value);
						return {id: act.id, name: act.name};
					})) : '';
				this.$api.setting.subject.batchAuxiliary(ids, value).then(() => {
					this.$Message('批量设置辅助核算成功');
					this.batchAuxForm.show = false;
					this.loadList();
				}).finally(() => {
					this.loading = false;
				});
			},
			doDisableChildren() {
				let ids = this.getSelectedIds();
				if (!ids.length) {
					this.$Message('请先勾选科目');
					return;
				}
				this.$Confirm('确认停用所选科目的全部下级科目？').then(() => {
					this.loading = true;
					this.$api.setting.subject.disableChildren(ids).then(({data}) => {
						this.$Message(data > 0 ? `已停用 ${data} 个下级科目` : '所选科目没有下级科目');
						this.loadList();
					}).finally(() => {
						this.loading = false;
					});
				});
			},
			doBatchDelete() {
				let ids = this.getSelectedIds();
				if (!ids.length) {
					this.$Message('请先勾选科目');
					return;
				}
				this.$Confirm(`确认删除勾选的 ${ids.length} 个科目？系统预置、已使用或存在下级科目的将被跳过。`).then(() => {
					this.loading = true;
					this.$api.setting.subject.batchDelete(ids).then(({data}) => {
						this.$Message(data.skipped > 0 ? `成功删除 ${data.deleted} 个科目，跳过 ${data.skipped} 个` : `成功删除 ${data.deleted} 个科目`);
						this.loadList();
					}).finally(() => {
						this.loading = false;
					});
				});
			},
			toggleStatus(data) {
				this.$api.setting.subject.update({id: data.id, status: data.status}).then(() => {
					this.$Message(data.status ? '已启用' : '已停用');
					this.loadList();
				}).catch(() => {
					this.loadList();
				});
			},
			isCashSubject(code) {
				return !!code && (code.indexOf('1001') === 0 || code.indexOf('1002') === 0 || code.indexOf('1009') === 0);
			},
			openCashFlow() {
				this.cashFlowForm.keyword = '';
				this.cashFlowForm.cashOnly = true;
				this.loading = true;
				Promise.all([
					this.$api.setting.subject.cashFlowItems(),
					this.$api.setting.subject.voucherSelect()
				]).then(([{data: items}, {data: subjects}]) => {
					this.cashFlowForm.items = items || [];
					this.cashFlowForm.datas = subjects || [];
					this.cashFlowForm.show = true;
				}).finally(() => {
					this.loading = false;
				});
			},
			changeCashFlow(data, value) {
				this.$api.setting.subject.setCashFlowItem(data.id, value || null).then(() => {
					this.$Message('现金流量对照已保存');
				});
			},
			loadAccountingCategory() {
				this.$api.setting.accountingCategory.list().then(({data}) => {
					this.accountingCategory = data;
				});
			},
			submit() {
				let validResult = this.$refs.form.valid();
				if (validResult.result) {
					this.toPy();
					this.loading = true;

					if (this.assistAccounting && this.auxiliaryAccounting.length) {
						this.form.auxiliaryAccounting = JSON.stringify(this.auxiliaryAccounting.map(value => {
							let act = this.accountingCategory.find(item => item.id == value);
							return {id: act.id, name: act.name};
						}));
					} else {
						this.form.auxiliaryAccounting = '';
					}

					if (this.numberAccounting && this.unit) {
						this.form.unit = this.unit;
					} else {
						this.form.unit = '';
					}

					this.$api.setting.subject[this.form.id ? 'update' : 'save'](Object.assign(this.form)).then(() => {
						this.loadList();
						this.showForm = false;
						this.loading = false;
					}).catch(() => {
						this.loading = false;
					})
				}
			},
			create(data) {
				this.parent = data;
				if (!data) {
					data = {level: 0, type: this.type, balanceDirection: '借'};
				}
				this.showForm = true;
				let children = this.datas.filter(value => value.parentId == data.id);
				let len = this.codeLen[data.level];
				this.len = len;
				let start = "1";
				if (children.length) {
					let code = children[children.length - 1].code;
					start = (parseInt(code.substr(code.length - len)) + 1) + "";
				}
				this.form.code = StringUtils.pad(start, 0 - (len - start.length), "0");
				this.form.type = data.type;
				this.form.parentId = data.id;
				this.form.level = data.level + 1;
				this.form.balanceDirection = data.balanceDirection;
			},
			change(data) {
				this.type = data.title;
			},
			remove(data) {
				this.$Confirm("确认删除?").then(() => {
					this.$api.setting.subject.delete(data.id).then(() => {
						this.loadList();
					})
				})
			},
			edit(row) {
				Api.setting.subject.checkUse(row.id).then(({data}) => {
					this.used = data;
					this.parent = this.datas.find(value => value.id == row.parentId);
					this.numberAccounting = !!row.unit;
					this.assistAccounting = !!row.auxiliaryAccounting;
					this.unit = row.unit;
					if (row.auxiliaryAccounting) {
						this.auxiliaryAccounting = JSON.parse(row.auxiliaryAccounting).map(val => val.id);
					}
					this.form = Object.assign({}, row);
					this.showForm = true;
				});
			},
			doUpload() {
			this.$refs.file.click();
		},
		fileChange(e) {
				if (this.$refs.file.files.length) {
					let formData = new FormData();
					formData.append('file', this.$refs.file.files[0]);
					this.loading = true;
					this.$api.setting.subject.import(formData).then(({data}) => {
						this.$Message("亲,导入成功~");
						this.loadList();
					}).finally(() => {
						this.loading = false;
					});
					this.$refs.file.value = "";
				}
			}
		},
		mounted() {
			this.codeLen = this.currentAccountSets.encoding.split("-").map(value => parseInt(value));
			if (this.currentAccountSets.accountingStandards !== 0) {
				this.tabDatas = [{
					title: '资产',
					key: 'CodeAssets'
				}, {
					title: '负债',
					key: 'CodeLiabilities'
				}, {
					title: '共同',
					key: 'Common'
				}, {
					title: '权益',
					key: 'CodeInterest'
				}, {
					title: '成本',
					key: 'CodeCost'
				}, {
					title: '损益',
					key: 'CodeLoss'
				}];
				//政府会计制度增加预算会计科目分组
				if (Number(this.currentAccountSets.accountingStandards) === 7) {
					this.tabDatas.push({
						title: '预算收入',
						key: 'BudgetIncome'
					}, {
						title: '预算支出',
						key: 'BudgetExpense'
					}, {
						title: '预算结余',
						key: 'BudgetBalance'
					});
				}
			}
			this.loadList();
			this.loadAccountingCategory();
		}
	};
</script>

<style scoped>
	div.h-tabs.h-tabs-card {
		border-bottom: 1px solid #52abc50d;
	}

	div.h-panel-body {
		padding-top: 0px;
	}

	div.h-panel-bar {
		border-bottom: 0px solid #eeeeee;
		border-top: 1px solid #eeeeee;
	}

	.used {
		position: absolute;
		right: 50px;
		z-index: 10;
		top: 0;
	}

	.subject-toolbar .h-checkbox {
		margin-right: 10px;
	}

	.batch-tip {
		margin-top: 10px;
		padding: 8px 12px;
		background: #f7f7f7;
		color: #999;
		font-size: 12px;
		border-radius: 4px;
	}

	.cashflow-list {
		max-height: 420px;
		overflow-y: auto;
	}

	.encode-box {
		.encode-rule {
			display: flex;
			align-items: center;
			justify-content: center;
			flex-wrap: wrap;
			font-size: 16px;
		}

		.encode-label {
			color: #333;
		}

		.encode-first {
			margin: 0 4px 0 8px;
			color: #333;
		}

		.encode-sep {
			margin: 0 6px;
			color: #333;
		}

		.encode-item {
			position: relative;
			display: inline-block;
			width: 70px;

			.h-select {
				width: 70px;
			}

			.encode-del {
				position: absolute;
				top: -8px;
				right: -8px;
				width: 16px;
				height: 16px;
				line-height: 14px;
				text-align: center;
				color: #fff;
				background: #ff4d4f;
				border-radius: 50%;
				font-size: 12px;
				cursor: pointer;
				display: none;
				z-index: 1;
			}

			&:hover .encode-del {
				display: block;
			}
		}

		.encode-add {
			margin-left: 12px;
			width: 24px;
			height: 24px;
			line-height: 22px;
			text-align: center;
			color: #fff;
			background: #001529;
			border-radius: 50%;
			font-size: 18px;
			cursor: pointer;
		}

		.encode-tip {
			margin-top: 15px;
			color: #999;
			font-size: 12px;
			line-height: 1.8;
		}
	}

	.merge-box {
		.m-row {
			display: flex;
			padding: 8px 0;
			align-items: center;

			.m-label {
				width: 150px;
				flex-shrink: 0;
			}

			select {
				flex: 1;
				max-width: 320px;
			}
		}

		.m-tip {
			margin-top: 10px;
			padding: 8px 12px;
			background: #f7f7f7;
			color: #999;
			font-size: 12px;
			border-radius: 4px;
		}
	}
</style>
